import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.unshift.js";
import DataForm from '@/core/work-components/data-form';
import SchemaSaver from './schema-saver';
import SchemaManager from './schema-manager';
export default {
  name: 'ConditionList',
  components: {
    DataForm,
    SchemaSaver,
    SchemaManager
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    quickSearchControls: Array,
    controls: Array,
    // 已选条件
    allControls: Array,
    // 所有可选条件
    schemas: Array,
    // 已保存方案
    canSave: Boolean,
    // 是否支持保存方案
    quick: Boolean,
    // 是否支持快速搜索
    labelWidth: String,
    // 表单的标签宽度
    labelPosition: String // 表单的标签对齐方式

  },
  data: () => ({
    keyword: '',
    // 弹出框中搜索条件的关键字
    controlsVisible: false,
    schemaSaverVisible: false,
    // 是否展示保存方案对话框
    schemaManagerVisible: false,
    // 是否显示更多方案
    schemaControls: [],
    editControls: [] // 编辑过程中需保存控件状态

  }),
  computed: {
    quickControls() {
      return (this.quickSearchControls || []).filter(item => !item.xtype);
    },

    quickPlaceholder() {
      return this.quickControls.map(item => item.options.label).join('/');
    },

    selectedMap() {
      return this.controls.reduce((ret, item) => ({ ...ret,
        [item]: true
      }), {});
    },

    selectedCount() {
      return this.editControls ? this.editControls.length : 0;
    },

    isAllSelected() {
      return this.filteredAllControls.length === this.editControls.length;
    },

    schema() {
      const selectedControls = this.filteredAllControls.filter(item => this.selectedMap[item.options.name]).map(item => {
        const newItem = { ...item,
          options: { ...item.options
          },
          xtype: item.options['search.xtype'] || item.xtype
        }; // data-from添加了下拉多选的支持，高级搜索也放开

        if (newItem.xtype === 'multi-select2') {
          newItem.xtype = 'select-multiple';
        } else if (!newItem.xtype) {
          newItem.xtype = 'text';
        }

        return newItem;
      });
      const controls = [...selectedControls];

      if (this.quickControls.length > 0) {
        controls.unshift({
          xtype: 'text',
          options: {
            name: 'keyword',
            label: '关键词',
            dataType: 'String',
            placeholder: this.quickPlaceholder
          }
        });
      }

      return {
        title: '表单',
        labelPosition: this.labelPosition,
        labelWidth: this.labelWidth,
        size: 'small',
        children: controls
      };
    },

    filteredAllControls() {
      return this.filterList(this.allControls);
    },

    fixedSchemas() {
      return this.schemas.filter(item => item.isFixed);
    }

  },
  methods: {
    doSearch() {
      this.$emit('search');
    },

    add() {
      this.editControls = [...this.controls];
      this.controlsVisible = true;
    },

    saveControlList() {
      this.$emit('change', this.editControls);
      this.controlsVisible = false;
    },

    removeControlByName(name) {
      const controls = [...this.controls];

      for (let i = 0, len = controls.length; i < len; i++) {
        if (controls[i] === name) {
          controls.splice(i, 1);
          this.$emit('change', controls);
          const newVal = { ...this.value
          };
          delete newVal[name];
          this.handleFormChange(newVal);
          break;
        }
      }
    },

    handleFormClick(e) {
      // 判断是否点击了删除图标，若点击了删除图标，则执行删除操作
      if (e.srcElement.className === 'el-form-item__content') {
        const {
          right,
          top,
          bottom
        } = e.srcElement.firstElementChild && e.srcElement.firstElementChild.getClientRects()[0]; // 计算删除图标所处的区域

        const iconLeft = right + 12;
        const iconRight = iconLeft + 14;
        const iconTop = top;
        const iconBottom = bottom;
        const {
          clientX,
          clientY
        } = e;

        if (clientX >= iconLeft && clientX <= iconRight && clientY >= iconTop && clientY <= iconBottom) {
          const name = e.srcElement.parentElement.getAttribute('prop');
          this.removeControlByName(name);
        }
      }
    },

    toggleAll() {
      if (this.isAllSelected) {
        this.editControls = [];
      } else {
        this.editControls = this.filteredAllControls.map(item => item.options.name);
      }
    },

    filterList(list) {
      const {
        keyword
      } = this;

      if (!keyword) {
        return list;
      }

      return list.filter(item => item.options.label.indexOf(keyword) > -1);
    },

    handleFormChange(value) {
      this.$emit('input', value);
    },

    async handleSchemaAdd(params) {
      this.$emit('schema-add', params);
    },

    async handleSchemaSave(item) {
      this.$emit('schema-save', item);
    },

    async handleSchemaDel(item) {
      this.$emit('schema-del', item);
    },

    selectSchema(schema) {
      this.$emit('schema-change', schema);
    },

    close() {
      this.$emit('close');
    }

  }
};